<template>
	<div class="editorProtocol">
		<Options v-if="treeMode != 'readonly' && !newProtocolViewBln" :diagram="diagram">
			<div class="diagramAddOn">
				<div class="overviewWrap">
					<button class="mapOpen" @click="overviewStatus = !overviewStatus">Map</button>
				</div>
				<div class="overview_wrap">
					<div class="overview" :class="{on: overviewStatus}">
						<div class="title_area">
							<strong class="tit">Map</strong>
						</div>
						<div id="editor-overview" class="editor_overview"></div>
					</div>
				</div>
				<div class="editorBtmWrap">
					<button v-if="treeMode=='templete' && !initChecked" @click="modeChange('normal')" class="mode">일반 모드로 이동</button>
<!--					<button v-if="treeMode=='templete' && initChecked" @click="modeChange('normal')" class="mode setting">일반 모드로 이동</button>-->
					<button v-if="treeMode=='normal'" @click="modeChange('templete')" class="mode normal">템플릿 수정 모드로 이동</button>
					<!-- 유닛 프로토콜 적용 버튼 제거 (2026-06 리뉴얼: 불필요 기능 정리) -->
					<!-- <button v-if="treeMode=='normal'" @click="searchUnit" class="mode unit">유닛 프로토콜 적용</button> -->
<!--          <button v-if="treeMode=='normal' && protocolType =='FULL'" @click="searchFull" class="mode unit">풀 프로토콜 적용</button>-->
					<!-- <button class="template" @click="templateToggleHandler">템플릿</button> -->
				</div>
			</div>
			
		</Options>
		<TreeNodeOption 
			v-if="treeMode == 'templeteEdit' || treeMode == 'templete'"
			@change="rendModel"
			:diagram="diagram"
			:treeMode="treeMode"
			:optionList="optionList"
			:selectedIssue="selectedIssue"
			:selectedNodes="selectedNodes"
			:tagTempleteData="tagTempleteData"
			:optionColors="optionColors"
		/>
		<!-- 우측 '프로토콜 기본정보' 패널 제거 (2026-06 리뉴얼: 불필요 기능 정리) -->
<!--		<LinkNode v-if="processInfoBln"
				  :processInfoSetOn="processInfoSetOn"
				  @change="linkNodeSetCheck($event)"
				  @openDictionaryPopup = "openDictionaryPopup"
				  :treeLoading.sync = "loading"
		/>-->
<!--		<LinkNodeForUnit v-if="processInfoUnitBln" :processInfoSetOn="processInfoSetOn" @change="linkNodeSetCheck($event)"/>-->
		<div class="canvas" id="editor-protocol"></div>
		<contextMenuTemplate 
			@contextMounted="getContext" 
			:crntObj="crntObj" 
			:memoObj="memoObj"
			:treeMode="treeMode"
			:renameNodeObj="renameNodeObj" 
			:addChildNodeObj="addChildNodeObj" 
			:addSiblingNodeObj="addSiblingNodeObj" 
		/>
		<Popup :crntObj="crntObj">
			<child-node :slot="`child`" :crntObj="crntObj" />
			<sibling-node :slot="`sibling`" :crntObj="crntObj" />
			<re-name-node :slot="`rename`" :crntObj="crntObj" />
		</Popup>
		<memo-node :memoObj="memoObj" />
		<new-protocol v-if="newProtocolViewBln" @click="makeProtocolModal=true" />
		<!-- <protocol-node 
			:addProtocolObj="addProtocolObj" 
		/> -->
		<!-- <button 
			:style="{
				background : '#333' , 
				color : '#fff' , 
				position : 'fixed' , 
				left : '50%' , top : '70px' , 
				zIndex : 9999 , 
				padding : '10px' , 
			}"
			@click="saveHandler"
		> test save </button> -->
		<ProcessSearch :type="processSearchMode"
			@select-protocol="selectProtocol($event)"
			:searchLinkData="searchLinkData"
			@setMethod="getChildMethods($event)"
      :overWriteProtocolMode="overWriteProtocolMode"
		/>
		<div class="undoRedoWrap" v-if="!newProtocolViewBln && treeMode != 'readonly'">
			<button @click="undoHandler" class="undo" :class="undoClass">undo</button>
			<button @click="redoHandler" class="redo" :class="redoClass">redo</button>
		</div>
		<MakeProcess Type="protocol|make" :active="makeProtocolModal" @confirm="addNewProtocolHandler" @close="makeProtocolModal=false"></MakeProcess>
		<!-- <Loading :visible="firstBln" type="fixed"/> -->
		<Loading :visible="loading" type="fixed"/>

    <div v-show="editStatusAlert" class="modalPopupLayout active">
      <div class="contentWrap">
        <h2 class="title" style="text-align: center">{{ editStatusTitle }}</h2>
        <div class="content">
          <p class="content" style="text-align: center; width: 300px" v-html="editStatusContent"></p>
        </div>
        <div class="ctrl" style="margin-top : 20px">
          <button class="sm_btn color_2" @click="$router.go( $router.currentRoute )">확인</button>
        </div>
      </div>
    </div>
	<dictionaryPopup :crntObj="dictionaryPopup"/>
	</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import { v4 } from "uuid";
import go from "gojs";
import CommNew, { commNewMapGetters, typeOfJson, replaceAllSpecialChar } from "@processEditor/CommNew";
import mixin from "@/mixins/process";
import contextMenuTemplate from './contextMenu.vue';

import Popup from "@components/common/Popup";
import ChildNode from "@components/protocolEditor/comp/ChildNode";
import SiblingNode from "@components/protocolEditor/comp/SiblingNode";
import ReNameNode from "@components/protocolEditor/comp/ReNameNode";
import MemoNode from "@components/protocolEditor/comp/MemoNode";
import NewProtocol from "@components/protocolEditor/comp/NewProtocol";
import ProtocolNode from "@components/protocolEditor/comp/ProtocolNode";
import TreeNodeOption from "@components/protocolEditor/comp/TreeNodeOption";
import LinkNode from "@components/protocolEditor/comp/LinkNode";
import LinkNodeForUnit from "@components/protocolEditor/comp/LinkNodeForUnit";
import Loading from '@common/loading.vue'
import Options from '@components/nav_process/Editor/options';
import { auto } from "@popperjs/core";
import MakeProcess from '@/components/modal/MakeProcess';
import {checkProtocolLink, protocolsInLink} from '@mixins/makeLinkInfo.js';
go.Diagram.licenseKey = "73f944eab16131b700ca0d2b113f69ef1bb37f3b9ed71ba75e5146f1ea5c6d173089ef7a01d58bc181a81aab182dc28ad4956c2a9f19016be031d78c44b284fae13161a2125d1788a45176c28bea29a0ff7a6ef2ddb1";

const goMake = go.GraphObject.make;

const ProcessSelector = createNamespacedHelpers('ProcessSearch');
import dictionaryPopup from '@modal/dictionaryPopup' ; 

export default {
	async beforeDestroy () {
		// console.log('Destroy : tree');
		this.updateStatus({ protocolTabMoveBln : false }) ; 
		window.removeEventListener( 'keydown' , this.keydownHandler ) ; 
		if ( this.user.name != 'AxiosError' ) {
			await this.saveHandler() ;
      this.pollingEndSwitch = true;
			this.updateStatus({ protocolTabMoveBln : true }) ; 
		}
	} , 
	mixins:[mixin , CommNew],
	components: {
		contextMenuTemplate , 
		Popup , 
		ChildNode , 
		SiblingNode , 
		ReNameNode , 
		MemoNode , 
		NewProtocol , 
		ProtocolNode , 
		TreeNodeOption,
		Loading , 
		Options,
		MakeProcess,
		LinkNode,
		LinkNodeForUnit,
		dictionaryPopup,
	},
	props : {
		firstBln : Boolean ,
        treeMode : {
            type : String, //normal : 일반모드 templeteEdit : 템블릿생성 templete : 템플릿 모드 readonly : 읽기전용
            default : ()=>{
                return "normal";
            }
        },
        tagTempleteData  : {
            type : Object,
            default : ()=>{
                return null;
            }
        },
        editKey : {
          type : String,
          default : null
        }
	} , 
	data () {
		return {
			processInfoSetOn : false, //PROCESS_INFO 정보가 입력 완료되었음을 확인
			processInfoBln : false,
			processInfoUnitBln : false,
			loading: false,
			nodeSetComplete : false, //full프로토콜일때 프로토콜 기본 연결정보 입력 여부 확인

			selectedNodes : [],
			optionValues : ["P","R","C","D","M","V","L","H","T"],
			optionColors : {"P":"forestgreen","R":"orange","C":"#4879BB","D":"chocolate","M":"crimson","V":"sienna","L":"darkred","H":"darkmagenta","T":"mediumvioletred"},
			optionList : [
                    {key:"P",name:"ParentNode",description:"최상위 노드",enable:false},
                    {key:"R",name:"RadioButton",description:"동일 노드층에 1개의 노드만 선택",enable:false},
                    {key:"C",name:"CheckBox",description:"동일 노드층에 1개 이상의 노드선택",enable:false},
                    {key:"D",name:"DirectionInput",description:"노드의 이름 수정가능",enable:false},
                    {key:"M",name:"Mandatory",description:"필수 입력값 지정(위원회 승인요청)",enable:false},
                    {key:"V",name:"ShortValue",description:"짧은 텍스트값 입력",enable:false},
                    {key:"L",name:"LongValue",description:"긴 텍스트값 입력",enable:false},
                    {key:"H",name:"HiddenNode",description:"비공개 설정",enable:false},
                    {key:"T",name:"ChildNodeToValue",description:"선택 하위 노드를 값으로 지정",enable:false},
                ],			
			nodeEditable : true,
			initChecked : false,
			expanderButtonVisible : true,

			multiSlctBln : false , 
			commandHandler : null , 
			undoManager : null , 

			makeProtocolModal: false,
			animationStartBln : false , 
			addProtocolObj : {
				openBln : false , 
				closeHandler : this.closeNewProtocolPopup , 
				addNewProtocol : this.addNewProtocolHandler , 
			} , 
			autoSaveTimer: undefined , 
			newProtocolViewBln : false , 
			diagram:{} , 
			overview: {},
			overviewStatus: false,
			nodeData: {} , 
			contextMenu: {} , 
			processType : 'NORMARL' , // 'ONLY_PROTOCOL' , // 현재 뭐하는지 아직 모르겠음. as-is 에서는 props로 받아오고있음
			crntProtocols : [] , 
			selectedIssue : [] , 

			connectProtocolMethod : {},

			renameNodeObj : {
				slotName : 'rename' , 
				openBln : false , 
				confirm : false , 
				text : '' , 
			} , 

			addChildNodeObj : {
				slotName : 'child' , 
				openBln : false , 
				confirm : false , 
				text : '' , 
			} , 
			addSiblingNodeObj : {
				slotName : 'sibling' , 
				openBln : false , 
				confirm : false , 
				text : '' , 
			} , 
			crntObj : {
				slotName : '' , 
				obj : {} , 
				closeHandler : this.closeCrntObjHandler , 
				updateHandler : this.updateCrntObjHandler , 
			} , 
			memoObj : {
				viewBln : false , 
				text : '' , 
				placeholder : '내용입력' , 
				obj : {} , 
				updateHandler : this.updateMemoObjHandler , 
				initHandler : this.initMemoObjHandler , 
				deleteHandler : this.deleteMemoObjHandler , 
			} ,

      searchLinkData : {},
      processSearchMode : null,
      overWriteProtocolMode : false,
      protocolType : null,
	    inProtocolId : null, // beforeDestroy에서 실행시키는 save 함수 내부에서 route의 protocolId를 사용하여 비교시 return 처리되기 때문에 변수 추가.
      editStatusAlert : false,
      editStatusTitle : "",
      editStatusContent : "",
      networkErrorCount : 0,
      pollingEndSwitch : false, 
	  dictionaryPopup : {
		 openBln : false , 
		 closeHandler : _=> this.dictionaryPopup.openBln = false , 
	   } , 
		}
	},
	computed : {
		...commNewMapGetters([
			'status' , 
		]) , 		
		...ProcessSelector.mapGetters(['getSelectedProcess']),
		undoClass () {
			// const { commandHandler } = this.diagram ; 
			const { commandHandler } = this ; 
			if ( !commandHandler ) return ; 
			return commandHandler.canUndo() ? null : 'unused' ; 
		} , 
		redoClass () {
			// const { commandHandler } = this.diagram ; 
			const { commandHandler } = this ; 
			if ( !commandHandler ) return ; 
			return commandHandler.canRedo() ? null : 'unused' ; 
		} , 
		
	} , 
	watch : {
		selectedNodes : {
			handler(data){
				if( !data.length ) return;
				// if( this.treeMode != "templete" ) return;
				if( this.treeMode != "normal" ) return;
				if( data.length > 1 ) return;

				const node = data[0];
				this.nodeDisplayChange( node );
			}
		},

		tagTempleteData : {
			async handler (data){
				console.log(this.crntProtocols, '~~~~~~~~!!!!! : ', data);
					if( !data.content ) return;
					if(!this.crntProtocols[0]) this.crntProtocols[0] = {json:null}
					this.crntProtocols[0].json = data.content;
					await this.setSelectedIssue() ; 
					this.setModel() ; 
			}
		},

		treeMode : {
			async handler(data){
				if(this.diagram.clearSelection != null && this.diagram.clearSelection != undefined){
				  this.diagram.clearSelection();
          await this.getProtocol() ;
				  await this.setSelectedIssue() ;
				  this.processInfoVisibleValid();
				  this.setModel() ;
				}
				if(this.diagram.nodes) {
					if (data == "readonly") {
						this.diagram.nodes.each(node => node.contextMenu = {});
					} else {
						this.diagram.nodes.each(node => node.contextMenu = this.contextMenu);
						if (this.treeMode != "readonly" && !this.newProtocolViewBln) {
							this.overview = new go.Overview('editor-overview', {
								observed: this.diagram
							})
						}
            await this.polling();
					}
				}
			}
		},

		firstBln : {
			handler ( bln ) {
				if ( bln ) return ; 
				this.setModel() ; 
			} , 
		} , 
		
		'$route.query.protocolId' : {
			async handler (newValue, oldValue) {
				// console.log( '==> $route.query.protocolId in : ', $route.query.protocolId ) ;
				this.inProtocolId = oldValue;
				this.$emit("forceRerender");
				await this.getProtocol() ; 
				await this.setSelectedIssue() ; 
				this.processInfoVisibleValid();				
				this.setModel() ; 
			} , 
		} , 
		slctProtocolKey : {
		// immediate : true , 
			handler () {
				if ( !this.multiSlctBln ) {
					// 싱글 셀렉트일 경우에 진입을 허가 
					if ( this.diagram.findNodeForKey ) {
						this.diagram.select( this.diagram.findNodeForKey( this.slctProtocolKey ) );
					}
				}
			} , 
		} , 
    'status.logHistoryBln' : {
			deep : true , 
			immediate : false , 
			async handler ( bln ) {
        if ( bln ) {
        //   console.log( 'zzzzzz' , bln ) ; 
					const getProtocols = await this.getProtocols() ; 	
					this.updateProtocols( getProtocols ) ; 

					await this.getProtocol() ; 
					await this.setSelectedIssue() ; 
					this.setModel() ; 
        }
			} , 
		} , 
		'status.protocolTabMoveBln' (bln) {
			console.log("Tree ~~~~~~ : ", bln);
			if ( bln ) {
				this.initFunc() ; 
			}
		} ,
		
	} , 
	async beforeMount () { // 이슈리스트 최초 열림 방지 // true : 열림 ; false : 닫힘 
		// this.updateStatus({ issueListViewBln : false }) ; 
	} , 
	async mounted() {
        // console.log("treeMode", this.treeMode)
		// await this.initFunc() ;
		this.inProtocolId = this.$route.query.protocolId; // 화면 렌더링 이후 setting.
		if(this.status.protocolTabMoveBln === true) {
			if( this.treeMode == "readonly" ) this.nodeEditable = false;
			// console.log('Tree mounted tab status : ', this.status.protocolTabMoveBln);
			await this.initFunc() ; 
		}
	},
  async beforeUpdate() {
      const { protocols } = this.PROCESS_INFO ;
      const crntProtocol = protocols?.filter(o=>o.id == this.$route.query.protocolId)[0];
      if(crntProtocol){
        this.protocolType = crntProtocol.protocolType;
      }
  },
	methods: {
		linkNodeSetCheck(data){
			this.nodeSetComplete = data;
			this.$emit("linkNodeSetCheck",data);
		},
		async selectProtocol(data){
			// console.log( "data", data )
			this.connectProtocolMethod.hide();
		    
			let targetProtocolInfo = await this.$wApi.protocol.getProtocols({ 
				processId : data.processId , 
				protocolId : data.protocolId , 
				isMemo : true , 
				isConent : true , 
				isComment  : true , 
			});    	

			let { json, nodeContent } = targetProtocolInfo[0];

			json = await typeOfJson( json );
			nodeContent = await typeOfJson(nodeContent);

			const crntProtocol = this.crntProtocols[0];
			const unitNodes = json.issues;
			let newUnitNodes = [];
			unitNodes.map((data) => {newUnitNodes.push(data)});
			
			// 유닛 프로토콜의 id를 저장. > 로그 및 노드 data 에서 사용.
			const referencedProtocolId = targetProtocolInfo[0].id;
			// 유닛 프로토콜의 부모 노드의 text를 저장. > confirm에서 사용.
			let unitNodeParentList = [];
			unitNodes.map((data) => {
				if(data.P === true && data.H !== true && !["작성자", "공정도", "용어설명"].includes(data.text)){
					unitNodeParentList.push(data.text);
				}
				if(data.H === true || ["작성자", "공정도", "용어설명"].includes(data.text)){
					deleteNodeAndChildren(data.key, newUnitNodes);
				}
			});
			let confirmMsg = `현재 작성 중인 \"프로토콜\"에 선택한\r\n
							\"유닛 프로토콜\"을 적용하시겠습니까?\r\n\r\n
							\"적용되는 항목은 해당하는 유닛 프로토콜로 교체 또는 추가됩니다.\"\r\n\r\n
							<font color="red">적용 대상 : `+unitNodeParentList.join(", ")+`</font>`;
			confirmMsg = confirmMsg.replace(/\r\n/gi, "<br/>");
			if (! await window.confirm(confirmMsg)) {
				return;
			}
			
			// loading component
			this.loading = true;
			
			let { protocols } = this.PROCESS_INFO; 
			let slctProtocol = protocols?.filter( protocol => protocol.id == crntProtocol.id )[0] ; 
			slctProtocol.json = await typeOfJson(slctProtocol.json);			
			
			// list 삭제 데이터 하위 데이터 모두 삭제.
			function deleteNodeAndChildren(nodeKey, dataList) {
			  const children = dataList.filter(item => item.parent === nodeKey);
			  
			  for (const child of children) {
			    deleteNodeAndChildren(child.key, dataList);
			  }
			
			  const index = dataList.findIndex(item => item.key === nodeKey);
			  if (index !== -1) {
			    dataList.splice(index, 1);
			  }
			}
			
       		//text로 기존 tree 비교 후 부모 노드만 남기고 하위 노드를 모두 삭제한다.
			newUnitNodes.map(async (unitNode) => {
			  // unitNode에 프로토콜 id 맞춰주기. 
			  unitNode.protocolId = crntProtocol.id;
       		  if (unitNode.P === true && unitNode.H !== true) {
       		  	// 해당 노드가 유닛을 연결한 노드인지 확인하는 flag값
			  	unitNode.unit = true;
			  	unitNode.unitProtocolId = referencedProtocolId;
       		  	//  유닛의 부모노드의 text와 에디터의 부모노드의 text를 비교하여 동일한 값을 확인한다.
       		    let data = slctProtocol.json.issues.find(o => o.text.trim() === unitNode.text.trim() && o.P === true);
       		    if(data) {
					let parentNode = this.diagram.findNodeForKey(data.key);
					// 삭제시 해당 노드가 유닛프로토콜인지 확인 후 로그를 남긴다. >> 삭제로그 필요시 open > insert 동작 확인 필요.
					// if (parentNode.data.unit === true) {
					// 	let deleteLog = await this.$wApi.protocol.unit.deleteLog({
					// 						fullProtocolId: slctProtocol.id,
					// 						unitProtocolId: parentNode.data.unitProtocolId,
					// 					});
					// 	console.log(deleteLog);
					// }
					// 자식 노드들을 선택
					let childrenNodes = parentNode.findTreeChildrenNodes();
					this.diagram.startTransaction("selectAllChildrenAndDelete");
					this.diagram.clearSelection();
					childrenNodes.each(function (childNode) {
						childNode.isSelected = true;
						deleteNodeAndChildren(childNode.data.key, slctProtocol.json.issues);
					});

					// 자식 노드를 삭제
					const command = this.diagram.commandHandler;
					command.deletesTree = true;
					command.deleteSelection();
					command.deletesTree = false;

					this.diagram.commitTransaction("selectAllChildrenAndDelete");

					// 데이터 맞춰주기.
					newUnitNodes.map((unitNodeChildNode) => {
						if (unitNodeChildNode.parent == unitNode.key) {
							unitNodeChildNode.parent = data.key;
						}
					});
					unitNode.key = data.key;
					unitNode.parent = data.parent;
				}
       		  }
       		});
			
       		// unit node의 값을 적용.
			for( let node of newUnitNodes ){

				let crntNode = slctProtocol.json.issues.find(o=>o.key === node.key);

				if( crntNode === undefined ){
					this.diagram.model.addNodeData(node)
					slctProtocol.json.issues.push(node)				
				}else{
					const diagramNode = this.diagram.findNodeForKey(node.key); 
					diagramNode.data = node;
					this.diagram.model.set(diagramNode.data);
					slctProtocol.json.issues.map( ( o , idx )=>{
						if( o.key === node.key ){
							slctProtocol.json.issues[ idx ] = node ; 
						}
					});
				}

			}

			

			for( let key in nodeContent ){
				if(newUnitNodes.filter(o=>o.key == key).length > 0) {
					const response = await this.$wApi.protocol.protocolContent.put({
						protocolId: crntProtocol.id,
						tagKey: key,
						content: nodeContent[key]
					});
					if (response.code) {
						await this.$wApi.protocol.protocolContent.put({
							protocolId: crntProtocol.id,
							tagKey: key,
							content: "<p><br/></p>"
						});
						await this.$wApi.protocol.protocolContent.put({
							protocolId: crntProtocol.id,
							tagKey: key,
							content: nodeContent[key]
						});
					}
					// console.log( "key", key )
					const nContent = nodeContent[key];
					if (nContent) {
						if (slctProtocol.json.issues.filter(o => o.key === key && o.V === true).length > 0 && nContent.replace(/(<([^>]+)>)/gi, '') != "") {
							this.diagram.model.addNodeData({
								isSelected: true,
								key: key + '-shortValue',
								parent: key,
								category: 'SHORTVALUE',
								visible: false,
								text: nContent.replace(/(<([^>]+)>)/gi, '')
							});
						}
					}
				}
			}

			await this.saveHandler() ; 
			
			await this.$wApi.protocol.unit.connectLog({
				fullProtocolId		:	slctProtocol.id,
				unitProtocolId		:	referencedProtocolId,
			});
			
			// loading component
			this.loading = false;
		},		
		searchUnit(){
      const { protocols } = this.PROCESS_INFO ;
      const ctrlProtocol = protocols?.filter(o=>o.id == this.$route.query.protocolId)[0];
      this.searchLinkData = {
        EQUIPMENT : {text:ctrlProtocol.equipment},
      }
      this.processSearchMode = 'unitProtocol';
			this.connectProtocolMethod.show();
		},
    searchFull(){
      const { protocols } = this.PROCESS_INFO ;
      const ctrlProtocol = protocols?.filter(o=>o.id == this.$route.query.protocolId)[0];
      this.searchLinkData = {
        ANALYSIS : {text:ctrlProtocol.analysis},
        EQUIPMENT : {text:ctrlProtocol.equipment},
        MATERIAL : {text:ctrlProtocol.material},
        keyOfProtocol : ctrlProtocol.keyOfProtocol,
        nowProtocolId : ctrlProtocol.id
      }
      this.processSearchMode = 'onlyProtocol';
      this.overWriteProtocolMode = true;
      this.connectProtocolMethod.show();
    },
		getChildMethods(methods){
			this.connectProtocolMethod = methods;
		},
		processInfoVisibleValid(){
			this.processInfoBln = false;
			this.processInfoUnitBln = false;
			if( this.$route.query.protocolId ){
				if( this.processType === 'ONLY_PROTOCOL' && this.treeMode === 'normal' && this.crntProtocols[0].protocolType === 'FULL' ){
					this.processInfoBln = true; //프로세스 정보 입력 완료
				}else if ( this.processType === 'ONLY_PROTOCOL' && this.treeMode === 'normal' && this.crntProtocols[0].protocolType === 'UNIT' ){
					this.processInfoUnitBln = true;
				}
			}
			this.processInfoSetOn = true;
		},
		async initFunc () {
			// console.log(this.treeMode, this.tagTempleteData)
			this.loading = true;
			if( this.treeMode == "templeteEdit" || ( this.treeMode == "readonly" && this.tagTempleteData ) ){
				// console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
				this.crntProtocols[0] = {};
				this.crntProtocols[0].json = this.tagTempleteData.content;
				// this.setProtocolId(-1);
				// console.log(this.crntProtocols);
			}else{
				const loadProcess = await this.$wApi.process.detail(null, this.$route.query.processId);
				this.processType = loadProcess.processType ; 
				if ( this.PROCESS_INFO.protocols == undefined ) await this.initElements() ; 
				await this.getProtocol() ; 
			}
			// console.log("this.crntProtocols", this.crntProtocols);

			this.processInfoVisibleValid();

			// console.log('########## Test : ', this.PROCESS_INFO.protocols)
			await this.setSelectedIssue() ; 
			await this.diagramInit()
      const { protocols } = this.PROCESS_INFO ;
      const crntProtocol = protocols?.filter(o=>o.id == this.$route.query.protocolId)[0];
      if(crntProtocol){
        this.protocolType = crntProtocol.protocolType;
      }
			this.loading = false;
			window.addEventListener( 'keydown' , this.keydownHandler ) ; 
			this.$emit('mount', {diagram: this.diagram})
		} , 
		logUndoSteps () {
			const { undoManager } = this.diagram ; 
			const { history , historyIndex } = undoManager ; 
			console.log( 'undoManager : ' , undoManager ) ; 
			console.log({ history , historyIndex }) ; 

			undoManager.isEnabled = true;

			console.log("------- UNDO HISTORY -------");
			// history.forEach(nction(change) {
  		// 	console.log(change.name + " at " + change.location.toString());
			// });

			let iterator = history.iterator;
			let idx = history.length - 1 ; 
			while (iterator.next()) {
				if ( historyIndex == idx ) {
					console.log( Object.keys( iterator.value ))
					console.log( iterator.__proto__ )
					const { name } = iterator.value ; 
					if ( name == 'Delete' ) {
						const nodeDataArray = this.diagram.model.nodeDataArray;

						let { protocols } = this.PROCESS_INFO ; 
						let { protocolId } = this.$route.query ; 

						const slctProtocol = protocols?.filter( protocol => protocol.id == protocolId )[0] ; 
						slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
						console.log({
							'slctProtocol.json' : slctProtocol.json , 
						})
						this.updateProtocols( protocols ) ; 
					}
				}

				let { value : event } = iterator ; 
				let { changes } = event ; 
				for (let key in changes) {
				}

				idx -= 1 ; 
			}
			console.log("---------------------------");

		} , 
		undoHandler () {
			// const { commandHandler } = this.diagram ; 
			const { commandHandler } = this ; 
			if ( commandHandler.canUndo() ) {
				commandHandler.undo() ; 
				this.logUndoSteps() ; 
			}
		} , 
		redoHandler () {
			console.log( 'redoHandler in' ) ; 
			// const { commandHandler } = this.diagram ; 
			const { commandHandler } = this ; 
			if ( commandHandler.canRedo() ) {
				commandHandler.redo() ; 
				this.logUndoSteps() ; 
			}
		} , 
		// async addNewProtocolHandler ({ text }) {
		async addNewProtocolHandler (makeInfo) {
			this.loading = true;
			// 기존의 정보가 있다면 불러온다. 
			let { links , nodes , protocols } = this.PROCESS_INFO ; 
			const processId = this.$route.query.processId ; 
			const protocolId = this.$route.query.keyOfProtocol ; 
			const keyOfProtocol = protocolId == null ? v4() : protocolId ; 

			const tagInfo = nodes.filter(o=>o.key === keyOfProtocol )[0];
			console.log( "makeInfo", makeInfo )
			if( tagInfo && tagInfo.tagId ){
				const protocolNew = await this.$wApi.protocol.create({
					processId : processId , 
					keyOfProtocol : keyOfProtocol , 
					name : makeInfo.kr , 
					nameEng : makeInfo.en,
					fieldId: makeInfo.field[makeInfo.field.length-1],
					active:true,
					// 과학기술분류 
					knsccId: makeInfo.requestKnscc.knsccId,
					// 과학기술표준분류코드 
					knsccCode: makeInfo.requestKnscc.knsccCode,
					// 과학기술표준분류명 
					knsccCodeName: makeInfo.requestKnscc.knsccCodeName,
					// 대분류코드 
					categoryLargeCode: makeInfo.requestField.categoryLargeCode,
					// 대분류명 
					categoryLargeCodeName: makeInfo.requestField.categoryLargeCodeName,
					// 중분류코드 
					categoryMiddleCode: makeInfo.requestField.categoryMiddleCode,
					// 중분류명 
					categoryMiddleCodeName: makeInfo.requestField.categoryMiddleCodeName,
					// 소분류코드(공정식별번호) 
					categorySmallCode: makeInfo.requestField.categorySmallCode,
					// 소분류코드명 
					categorySmallCodeName: makeInfo.requestField.categorySmallCodeName,
					// 소소분류코드(하부공정식별번호) 
					categoryMicroCode: makeInfo.requestField.categoryMicroCode,
					// 소소분류코드명 
					categoryMicroCodeName: makeInfo.requestField.categoryMicroCodeName,
				}) ;

				// console.log( "protocolNew", protocolNew )
				// tagInfo.tagId = -1;
				let tagTemplate = await this.$wApi.tag.template.get({tagId:tagInfo.tagId},tagInfo.tagId) ; 
				if( !tagTemplate.id ){
					tagTemplate = await this.$wApi.tag.template.get({tagId:-1},-1) ; 
				}
				tagTemplate.content = JSON.parse(tagTemplate.content);
				for( let node of tagTemplate.content.issues ){
					node.protocolId = protocolNew.protocolId;
				}
				const data = await this.$wApi.protocol.put({
					protocolId : protocolNew.protocolId , 
					name : makeInfo.kr , 
					nameEng : makeInfo.en,
					protocolType : makeInfo.protocolType,
					keyOfProtocol , 
					content : JSON.stringify( { ...tagTemplate.content, init : true } ) , 
					// 과학기술분류 
					knsccId: makeInfo.requestKnscc.knsccId,
					// 과학기술표준분류코드 
					knsccCode: makeInfo.requestKnscc.knsccCode,
					// 과학기술표준분류명 
					knsccCodeName: makeInfo.requestKnscc.knsccCodeName,
					// 대분류코드 
					categoryLargeCode: makeInfo.requestField.categoryLargeCode,
					// 대분류명 
					categoryLargeCodeName: makeInfo.requestField.categoryLargeCodeName,
					// 중분류코드 
					categoryMiddleCode: makeInfo.requestField.categoryMiddleCode,
					// 중분류명 
					categoryMiddleCodeName: makeInfo.requestField.categoryMiddleCodeName,
					// 소분류코드(공정식별번호) 
					categorySmallCode: makeInfo.requestField.categorySmallCode,
					// 소분류코드명 
					categorySmallCodeName: makeInfo.requestField.categorySmallCodeName,
					// 소소분류코드(하부공정식별번호) 
					categoryMicroCode: makeInfo.requestField.categoryMicroCode,
					// 소소분류코드명 
					categoryMicroCodeName: makeInfo.requestField.categoryMicroCodeName,
				});
				// console.log( "tagTemplate", tagTemplate )
			}
			this.loading = false;
			this.makeProtocolModal = false;
			this.$router.go( this.$router.currentRoute ) ; 
			// await this.getProtocol() ; 
			// this.setSelectedIssue() ; 
			// this.setModel() ; 
			// console.log( "links", links )
			// console.log( "nodes", nodes )

		} , // end of addNewProtocolHandler 

		closeNewProtocolPopup () {
			this.addProtocolObj = { ...this.addProtocolObj , openBln : false } ; 
		} , 
		makeNewProtocol () {
			this.addProtocolObj = { ...this.addProtocolObj , openBln : true } ; 
		} , 
		keydownHandler ( e ) {
			let { ctrlKey , key } = e ; 
			// console.log( 'this.firstBln : ' , this.firstBln ) ; 
			setTimeout(_=>{
				if ( ctrlKey ) {
					e.preventDefault() ; 
					switch ( key ) {
						case 's' : 
							if ( this.firstBln ) return ; 
							// console.log('aaaaa'); 
							this.saveHandler() ; 
							break ; 
						case 'r' :
							if ( this.firstBln ) return ; 
							this.$router.go( this.$router.currentRoute ) ; 
							break ; 
					}
				}
			} , 1000 )
		} , 
		saveTimer () {
            this.autoSaveTimer = setTimeout( _=> {
                this.saveHandler() ; 
            } , this.saveDuration ) ; 
		} , 
		async saveHandler (releaseFlag) {
			if( this.treeMode == "templeteEdit" || this.treeMode == "readonly" ) return;
			//템플릿 생성 모드일때는 저장을 이쪽에서 하지 않아요.

			const { protocols } = this.PROCESS_INFO ; 
			let crntProtocol = null ; 

			if( !protocols || protocols.length == 0 ) return;
			
			let inProtocolId = this.$route.query.protocolId;
			if ( !inProtocolId ){ // route가 지워진 경우.
				inProtocolId = this.inProtocolId;
			}else if (this.$route.query.protocolId != this.inProtocolId) { // issue list에서 프로토콜 변환이 일어난 경우.
				inProtocolId = this.inProtocolId;
			}
			
			protocols.map(( p , idx ) => {
				if ( inProtocolId == p.id ) {
					// console.log( this.$route.query.protocolId , p.keyOfProtocol , idx ) 
					crntProtocol = p ; 
					return ; 
				}
			}) ; 

			if ( crntProtocol == null ) return ; 
			let {
				id : protocolId , 
				name , 
				keyOfProtocol , 
				json , 
				protocolType,
				nameEng,
				
			} = crntProtocol ; 

			/** 로그 등록 */
			await this.$wApi.trace.log({
				type : 'PR', //PD 공정도, PR 프로토콜
				code : 'M', //N 생성 M 수정 S 검색 R 조회
				subCode : '01',
				keyword : '',
				result : 0,
				ptlId : protocolId
			});
			/** 로그 등록 */  

			// console.log( "this.PROCESS_INFO", this.PROCESS_INFO )

			// 기본정보 패널 제거에 따라 장비/목적/재료 선택 안내도 비활성화 (2026-06 리뉴얼)
			// if( this.treeMode == 'normal' && this.processType == 'ONLY_PROTOCOL' && protocolType == 'FULL' && this.nodeSetComplete === false ){
			// 	window.alert( `트리 우측 '프로토콜 기본정보'의 장비,목적,재료를 선택해주세요. ` );
			// }


			// console.log('protocols : ', protocols); 
			// console.log('crntProtocol : ', crntProtocol); 
			
			const saveBeforStringChkFun = _=> {
				return new Promise( resolve => {
					const loopFunc = _=> {
						if ( typeof json == 'object' ) {
							resolve() ; 
						} else {
							json = JSON.parse( json ) ; 
							if ( typeof json == 'string' ) {
								loopFunc() ; 
							} else {
								resolve() ; 
							}
						}
					}
					loopFunc() ; 
				}) ; 
			} ; 
			await saveBeforStringChkFun() ; 

			/**
			 * json 데이터 중에 child는 저장을 위한 데이터가 아닌 이슈리스트 및 wiki 등에서 현상 관리를 위한 property 이므로 
			 * 저장 전에 삭제
			 */
			for( let item of json.issues ) {
				delete item.child;
				delete item.points;
			}

			json.issues = json.issues.filter( o=>o.category != 'SHORTVALUE' );

			// console.log( 'treeNew.vuew ----> json : ' , json ) ;

      //동시수정 방지. editKey로 유효한 키인지 확인 => 유효하지않을 경우 저장X
      const res = await this.$wApi.simultaneous.saveable({
         editKey : this.editKey
      });
      if(!res.isSaveable){
        this.loading = false;
        return;
      }

			const data = await this.$wApi.protocol.put({
				protocolId , 
				// name , 
				// nameEng,
				protocolType,
				keyOfProtocol , 
				content : JSON.stringify( json ) , 
			});
			/* {
				"protocolId": 1,
				"name": "프로토콜 이름 샘플",
				"keyOfProtocol": "태그 고유 아이디",
				"json": "프로토콜 내용 json"
			} */
			
			/*자동저장 로그 insert*/
			if (releaseFlag != true) { // 공개 팝업 open 직전 자동 저장의 경우 modify version을 상승시키지 않음. (공개 완료 후 backend에서 log insert)
				const autoSaveResPonse = await this.$wApi.protocol.autoSave.create({protocolId: protocolId});
			}

			window.wToast("프로토콜 자동저장을 완료하였습니다." , {
                variant: "wtoast-bg",
            }) ; 
			console.log('Tree save');
		} , 
		async setSelectedIssue (rowKey=0) {
			// console.log( 'setSelectedIssue in' ) ; 
			let { crntProtocols } = this ; 
			// console.log( protocolId , crntProtocols )
			if ( !crntProtocols || !crntProtocols.length ) {
				this.selectedIssue = [] ; 
				return ; 
			}

			const nodes = crntProtocols
				// .map((p) => (p.json && p.json !== {} ? JSON.parse(p.json).issues : []))
				.map((p) => {
					if ( p.json && p.json !== {} ) {
						if ( typeof p.json == 'string' ) {
							return JSON.parse( p.json ) ; 
						} else {
							return p.json ; 
						}
						// return typeof p.json == 'string' ? JSON.parse( p.json ).issues : p.json.issues ; 
					} else {
						return [] ; 
					} 
				})
				.flat()
				.filter((i) => !!i) 
			;

			let crntProtocol = crntProtocols[rowKey];
			let putData = {};
			const { nodeMemo, nodeContent } = crntProtocol ; 
			const issuesData = { ...nodes[rowKey] };

			// console.log( "issuesData", issuesData )

			if( issuesData?.init === true ){
				if( this.treeMode !== 'templeteEdit' ){
					putData = {
						"protocolId": crntProtocol.id,
						"fieldId": Number(crntProtocol.fieldId.split('>').pop()),
					}
					let nodeInfo = checkProtocolLink(this.PROCESS_INFO.links, this.PROCESS_INFO.nodes, crntProtocol.keyOfProtocol);
					nodeInfo = nodeInfo.nodeInfo;
					for(let item of Object.entries(nodeInfo)) {
						// 프로토콜에 연결된 모든 노드의 정보를 넘기는것이 아닌 직접적으로 연결된 재료,목적,장비만 넘기도록 수정.
						// putData[item[0].toLowerCase()] = (Object.keys(item[1])).join(';');
						putData[item[0].toLowerCase()] = Object.keys(item[1])[0];
						// 장비노드의 id를 추가로 전달.
						if(item[0] == "EQUIPMENT"){
							putData.idEquipment = item[1][Object.keys(item[1])[0]][0]["tagId"];
						}
					}
					if( putData.analysis ){
						putData.measurement = " ";
					}else if( putData.measurement ){
						putData.analysis = " ";
					}
					// console.log( "putData", putData )
					await this.$wApi.protocol.put(putData);
				}
				// this.initChecked = true;
			}else{
				if( this.treeMode !== 'templeteEdit' ){
					putData = {
						"protocolId": crntProtocol.id,
						"fieldId": Number(crntProtocol.fieldId.split('>').pop()),
					}
					let nodeInfo = checkProtocolLink(this.PROCESS_INFO.links, this.PROCESS_INFO.nodes, crntProtocol.keyOfProtocol);
					nodeInfo = nodeInfo.nodeInfo;
					for(let item of Object.entries(nodeInfo)) {
						// 프로토콜에 연결된 모든 노드의 정보를 넘기는것이 아닌 직접적으로 연결된 재료,목적,장비만 넘기도록 수정.
						// putData[item[0].toLowerCase()] = (Object.keys(item[1])).join(';');
						putData[item[0].toLowerCase()] = Object.keys(item[1])[0];
						// 장비노드의 id를 추가로 전달.
						if(item[0] == "EQUIPMENT"){
							putData.idEquipment = item[1][Object.keys(item[1])[0]][0]["tagId"];
						}
					}

					if( putData.analysis ){
						putData.measurement = " ";
					}else if( putData.measurement ){
						putData.analysis = " ";
					}
					// console.log( "putData", putData )					
					await this.$wApi.protocol.put(putData);
				}

				this.initChecked = false;
			}
			// console.log( "issuesData2", issuesData )
			crntProtocols[rowKey].json = issuesData ; 
			// crntProtocol.fieldId = Number(crntProtocol.fieldId.split('>').pop());
			let shortValues = [];
			for ( let issue of issuesData.issues ) {
				let { key , protocolId } = issue ;  

				issue.visible = false ; 
				delete issue.temporaryText ; 
				/**
				 * 이슈에 기존 없던 child 데이터가 추가 되어 옴 이 데이터 때문에 위키에 데이터가 중복 호출 됨
				 * child가 어디서 추가되고 있는지 확인 필요
				 * 현재 child를 삭제함으로써 정상 동작
				 */
				delete issue.child;
				if( nodeContent ){
					if( issue.V === true && nodeContent[issue.key] && nodeContent[issue.key].replace(/(<([^>]+)>)/gi, '') != "" ){
						let shortText = nodeContent[issue.key].replace(/(<([^>]+)>)/gi, '');
						shortText = replaceAllSpecialChar(shortText);
						shortValues.push({display:issue.display, isSelected:true, key:issue.key+'-shortValue', parent:issue.key, category:'SHORTVALUE', visible:false, text:shortText})
					}
				}
				if ( nodeMemo != null ) {
					for ( let [ memoKey , memoValue ] of Object.entries( nodeMemo )) {
						if ( memoKey == key ) {
							// console.log({ memoKey }) ; 
							if ( memoValue != null ) {
								issue.visible = true ; 
								issue.temporaryText = memoValue ; 
							}
						}
					} ; 
				}
			}
			// console.log( "issuesData3", issuesData )
			this.selectedIssue = [ ...issuesData.issues ] ; 
			if( shortValues.length > 0 ) this.selectedIssue.push( ...shortValues )
		} , 
		updateMemoObjHandler ( info ) {
			// console.log({ info }) ; 
			this.memoObj = { ...this.memoObj , ...info } ; 
			// this.setSelectedIssue() ; 
		} , 
		async deleteMemoObjHandler ({ tagKey , protocolId }) {
			// 메모 삭제 기능 
			/* console.log({
				tagKey , 
				protocolId , 
			}) ; 
			const oldMemo = await this.$wApi.protocol.memo.get({
				protocolId , 
				tagKey , 
			}) ; 
			console.log({ oldMemo }) */

			// const res = await this.$wApi.protocol.memo.put({
			// 	protocolId : this.editor.protocolId,
			// 	tagKey: this.editor.key,
			// 	content: e.target.innerText
			// }, null);

			const rslt = await this.$wApi.protocol.memo.put({
				protocolId , 
				tagKey , 
				content : null , 
			}) ; 

			// const { obj : { memoBtn }} = this.memoObj ; 
			this.diagram.selection.each(( node )=>{
				const btn = node.findObject('memoBtn') ; 
				btn.visible = false ; 
				// memoBtn.visible = false ; 
				delete node.part.temporaryText ; 
				delete node.data.temporaryText ; 
			}) ; 
		} , 
		initMemoObjHandler () {
			if( this.treeMode == "readonly" || this.treeMode == "templeteEdit" ) return;
            this.diagram.selection.each(( node )=>{
				
                const { elements , key , data : { temporaryText = '' }} = node ; 
                const btn = node.findObject('memoBtn') ; 
                const textValue = node.findObject('textValue') ; 
                const {
                minSize , 
                maxSize , 
				metrics,
                part : {
                    location , 
                } , 
                } = textValue ; 
				console.log( "textValue", textValue )
                let docloc = this.diagram.transformDocToView( location ) ; 
                // let width = Math.max( minSize.width , maxSize.width ) ; 
				// let width = Math.max( minSize.width, metrics.maxLineWidth ) - 20 ; 
				let width = (node.actualBounds.width + (node.findObject("NodeShape").figure == "CapsuleH" ? 2 : 10)) * this.diagram.scale ; // node의 shape을 확인 후 margin을 더해줌.
                let height = Math.max( minSize.height , maxSize.height ) ; 
                let canvas = document.querySelector( '#editor-protocol > canvas' ) ; 

                /* console.log(
                'temporaryText : ' , temporaryText , 'n' , 
                'textValue : ' , textValue , '\n' , 
                'location : ' , location , '\n' , 
                'docloc : ' , docloc , '\n' , 
                'key : ' , key , '\n' , 
                'width : ' , width , '\n' , 
                'height : ' , height , '\n' , 
                'canvas : ' , canvas , '\n' , 
                'left : ' , canvas.getBoundingClientRect().left , 
                'top : ' , canvas.getBoundingClientRect().top , 
                ) ;  */

                this.memoObj.updateHandler({ 
                viewBln : true , 
                text : temporaryText , 
                diagram : this.diagram , 
                obj : {
                    textValue , 
                    location , 
                    docloc , 
                    key , 
                    memoBtn : btn , 
                    size : { width , height } , 
                    pos : { 
                    left : canvas.getBoundingClientRect().left , 
                    top : canvas.getBoundingClientRect().top , 
                    } , 
                } , 
                }) ; 

                /* this.memeObj.updateHandler({
                textValue , 
                location , 
                docloc , 
                key , 
                size : { width , height } , 
                pos : { left , top } , 
                }) ;  */
                // btn.visible = true ; // 메모 활성화 유무 
                
            }) ; 
		} , 

		closeCrntObjHandler () {
			// console.log( this.crntObj.slotName ) ; 
			let obj = {} ; 
			switch ( this.crntObj.slotName ) {
				case 'child' : 
					Object.assign( this.addChildNodeObj , { ...this.addChildNodeObj , openBln : false , confirm : false }) ; 
					Object.assign( obj , { ...this.addChildNodeObj }) ; 
					break ; 
				case 'sibling' : 
					Object.assign( this.addSiblingNodeObj , { ...this.addSiblingNodeObj , openBln : false , confirm : false }) ; 
					Object.assign( obj , { ...this.addSiblingNodeObj }) ; 
					break ; 
			}
			Object.assign( this.crntObj , {
				...this.crntObj , 
				obj , 
			}) ; 
		} , 
		updateCrntObjHandler ({ type , ...newObj }) {
			/* console.log( 
				'type : ' , type , 
				'newObj : ' , newObj , 
			) ;  */

			let obj = {} ; 
			// console.log('updateCrntObjHandler : ', newObj, this.renameNodeObj, this.crntObj)
			switch ( type ) {
				case 'child' : 
					Object.assign( this.addChildNodeObj , { ...this.addChildNodeObj , ...newObj }) ; 
					Object.assign( obj , { ...this.addChildNodeObj }) ; 
					break ; 
				case 'sibling' : 
					Object.assign( this.addSiblingNodeObj , { ...this.addSiblingNodeObj , ...newObj }) ; 
					Object.assign( obj , { ...this.addSiblingNodeObj }) ; 
					break ; 
				case 'rename' : 
					Object.assign( this.renameNodeObj , { ...this.renameNodeObj , ...newObj }) ; 
					Object.assign( obj , { ...this.renameNodeObj }) ; 
					break ; 
			} 
			
			Object.assign( this.crntObj , {
				...this.crntObj , 
				slotName : type , 
				obj , 
			}) ; 
		} , 
		addChildNodeBlnHandler () {
			this.addChildNodeBln = !this.addChildNodeBln ; 
		} , 
		addChildNodeHandler () {
			this.addChildNodeBln = !this.addChildNodeBln ; 
		} , 
		async getProtocol () {
			let data, storeData;
			let { user , $route : { query }} = this ; 
			this.setInitInfo({ user , query }) ; 

			if( !this.$route.query.processId ) return;

			const loadProcess = await this.$wApi.process.detail(null, this.$route.query.processId);
			this.processType = loadProcess.processType ; 

			const getProtocols = await this.getProtocols() ;
			// data = this.PROCESS_INFO.protocols ; 
			data = getProtocols;

			// console.log( "getProtocols",getProtocols )
			// console.log( "data",data )
			if ( !data ) return ; 

			// storeData = this.PROCESS_INFO.protocols;
			storeData = data ; 
			this.crntProtocols = [] ; 

			// console.log({ 
			// 	data , 
			// 	storeData , 
			// 	processType : this.processType , 
			// })

			if ( !data ) return ; 
			if ( data.length == 0 ) {
				this.newProtocolViewBln = true ; 
				return ; 
			}

			const chkID = data.some( info => info.id == this.$route.query.protocolId ) ; 
			if ( !chkID ) {
				this.newProtocolViewBln = true ; 
				return ; 
			}

			if ( data ) {
				if ( this.processType === 'ONLY_PROTOCOL' ) {
					this.crntProtocols = data.filter( p => p.id == this.$route.query.protocolId ) ;
				} else {
					// this.crntProtocols = data.filter( p => p.parent === this.protocolId ) ; 
					this.crntProtocols = data.filter( p => p.id == this.$route.query.protocolId ) ;

					// console.log({
					// 	crntProtocols : this.crntProtocols , 
					// 	storeData , 
					// 	protocolId : this.protocolId , 
					// }) ; 
					
					if(storeData) {
						storeData = storeData.filter( p => {
							if ( p.id == this.$route.query.protocolId ) {
								return p ; 
							}
						})[0];

						// console.log({
						// 	storeData , 
						// }) ; 

						if ( !storeData ) {
							this.newProtocolViewBln = true ;
							return ; 
						}
						// storeData[0].json = typeof storeData[0].json ==='string' ? JSON.parse(storeData[0].json) : storeData[0].json;
						const saveBeforStringChkFun = _=> {
							return new Promise( resolve => {
								const loopFunc = _=> {
									if ( typeof storeData.json == 'object' ) {
										resolve() ; 
									} else {
										storeData.json = JSON.parse( storeData.json ) ; 
										if ( typeof storeData.json == 'string' ) {
											loopFunc() ; 
										} else {
											resolve() ; 
										}
									}
								}
								loopFunc() ; 
							}) ; 
						} ; 
						await saveBeforStringChkFun() ; 
						/* let jsonNew = null ; 
						if ( typeof storeData.json === 'string' ) {
							// storeData.json = storeData.json.replace( /\\"/g , '"' ) ; 
							// storeData.json = JSON.parse( storeData.json ); 
							jsonNew = JSON.parse( storeData.json ); 
							// jsonNew = JSON.parse( jsonNew ); 
							storeData.json = jsonNew ; 
						} */
						
						// Object.assign(this.crntProtocols, storeData)
						// this.crntProtocols[0].json = Object.assign({}, jsonNew); 
						this.crntProtocols[0].json = Object.assign({}, storeData.json);
					} 
				}
			} else {
				this.crntProtocols = [] ; 
				// 트리에 그려줄 프로토콜이 없다. 
			}

			// console.log( "this.crntProtocols", this.crntProtocols )

			this.newProtocolViewBln = this.crntProtocols.length == 0 ? true : false ; 

			this.crntProtocols.map( p => {
				if ( typeof p.json === 'string' ) {
					const newJ = JSON.parse( p.json ) ; 
					// p.json = JSON.parse( p.json ) ; 
					p.json = newJ ; 
				}
			}) ; 
		} , 
		addNodeRounedLabel(keyName,color){
			let imageSrc = this.getImageUrl(keyName);
			return goMake(go.Panel, "Auto",{
  							alignment: go.Spot.Right,
						  	alignmentFocus: go.Spot.Right,
							margin : new go.Margin(3.5,3,2,0),
						},
						goMake(go.Shape,{
								figure: "RoundedRectangle",
								strokeWidth:0.5,
								fill:"#ffffff",
								stroke: "#B3B9BD",
								stretch: go.GraphObject.Fill,
								maxSize: new go.Size(20, 18.5),
							}
						),
						goMake(go.Picture,
							{
								source: imageSrc,
								maxSize: new go.Size(16, 16),
							},
							new go.Binding("visible", "", function(data) {
								let visible = false;
								if( data.data[keyName] === true ) visible = true;
								return visible;
								// return true;
							}).ofObject(),
						),
						new go.Binding("visible", "", function(data) {
							let visible = false;
							if( data.data[keyName] === true ) visible = true;
							return visible;
							// return true;
						}).ofObject(),
			)	
		},
		addNodeLabel(){
			let rounedLabels = [];
			//템플릿 수정모드일때만 속성값 노출
			// if( this.treeMode == "templeteEdit" || this.treeMode == "templete" ){
			for( let optKey of this.optionValues ) rounedLabels.push( this.addNodeRounedLabel(optKey,this.optionColors[optKey]) );
			// }
			// console.log( "rounedLabels", rounedLabels )
			return goMake(go.Panel, "Position",
						{ 
							margin : new go.Margin(0,0,0,0),
							height : 20,
							position: new go.Point(0, 100), // 트리노드 우측 상단에 위치
							alignment: go.Spot.BottomLeft, // 정렬 위치
							alignmentFocus : go.Spot.Left , 
						},
						// goMake(go.Shape,{
						// 	stroke : "red",
						// }),
						new go.Binding( 'visible', 'data' , ( data ) => {
							let visible = false;
							if( this.treeMode == "templeteEdit" || this.treeMode == "templete" ){
								visible = true;
							}
							return visible; 
						}).ofObject(),				


						goMake(go.Panel, "Auto",{
							alignment: go.Spot.Left,
							margin : new go.Margin(0,0,0,0),
							stretch: go.GraphObject.Fill,
							height:20,
							padding: 0,
						},
						goMake(go.Panel,"Horizontal",
							{
								alignment: go.Spot.Left,
								height:20,
								padding: new go.Margin(0, 2, 0, 0)
							},
							rounedLabels
						),
					)


				)
		},
		diagramInit () {
			const diagramElement = document.getElementById('editor-protocol');
			if( !diagramElement ) return;

			const testNode = goMake(go.Panel, 'Spot', 
				{
				alignmentFocus: go.Spot.Center,
				cursor: 'pointer'
				},
				goMake( go.Shape,{
					width:30,height:30,
					stroke:"red",
					fill:"white"
				} )
			);

			const nodeTemplateMapped = new go.Map();
			this.diagram = new go.Diagram("editor-protocol", {
				"ChangedSelection": e => {
					let findKey = null ; 
					this.selectedNodes = []; //선택 노드 정보를 초기화
					// console.log("selection")
					// Shift 키가 눌렸을 때의 동작 유무
					this.multiSlctBln = e.diagram.lastInput.shift ? true : false ; 
					this.diagram.selection.each(( item ) => {
						let parentData = this.selectedIssue.filter(o=>o.key == item.data.parent)[0];
						this.selectedNodes.push({...item.data,parentData});
						
						let { parent , key } = item.data ; 

						if (item.data.category === 'SHORTVALUE') {
							item.isSelected = false;
						} 

						// if ( typeof parent == 'number' ) {  노드 속성 지정 후 선택해제를 막기 위해 주석 처리함
							this.updateState({ slctProtocolKey : key }) ; 
						// }
					}) ; 
				} , 
				layout: goMake(go.TreeLayout, {
					// tree 기본 간격 조정.
                    isOngoing: true,
                    isInitial: true, 
					nodeSpacing: 15, 
					layerSpacing: 40,
					arrangementSpacing: new go.Size(0,15),
                }),
                // layout: goMake(go.TreeLayout),
                "undoManager.isEnabled": true,
				// "clickSelectingTool.isEnabled": true, 
				// allowSelect: true, 
                        
                // 확대 정도
                scale: 1,
                maxScale: 3,	
                minScale: 0.2, 
				
				// contentAlignment : go.Spot.RightCenter , 
				contentAlignment : ( this.treeMode == "templeteEdit" ) ? go.Spot.Center : new go.Spot(0.25, 0.5, 0, 0) , 
				nodeTemplate : goMake(go.Node, "Spot",
					{
						selectionObjectName: "PANEL",
						contextMenu : this.treeMode != "readonly" ? this.contextMenu : {},
						selectionAdornmentTemplate : goMake( go.Adornment , 
							'Spot' , 
							{ layerName: 'Background' } , 
							goMake(go.Panel, "Auto", 
								{
									name : 'adornment'
								} , 
								goMake( go.Shape, 'CapsuleH', {
									stroke: '#189EA7', 
									strokeWidth: 2, 
									strokeDashArray: [5,4], 
									strokeDashOffset: 4,
									fill: 'transparent',
								} ,
								new go.Binding("figure","data",(data)=>{
									let figure = "capsuleH";
									// if(data.V === true || data.L === true){
									// 	figure = "RoundedRectangle";
									// }
									return figure;
								}).ofObject(),
								),
								goMake(go.Placeholder,{
									padding: new go.Margin(3,3,3,3),
								}),
							),
						) , 
						mouseEnter:(e,obj)=>{
							if( this.expanderButtonVisible ){
								if( obj.findTreeChildrenNodes().count > 0 ){
									// console.log( "childNodes", obj.findTreeChildrenNodes() )
									obj.findObject("TREEBUTTON").opacity = 1;
								}
							}
						},
						mouseLeave:(e,obj)=>{
							if( this.expanderButtonVisible ){
								if(obj.isTreeExpanded){
									obj.findObject("TREEBUTTON").opacity = 0;	
								}else{
									obj.findObject("TREEBUTTON").opacity = 1;
								}
							}
							
						},
					},
					new go.Binding( 'visible', 'data' , ( data ) => {
						let visible = true;
						if ( data.H == true && this.treeMode == "readonly" ) {
							visible = false;
						}

						if( ( this.treeMode == "readonly"/* || this.treeMode == "normal" */) && data.display !== undefined && data.display === false ){
							visible = false;
						}

						return visible ; 
					}).ofObject() , 					
					goMake(go.Panel, "Auto",
						{ 
							name: "PANEL" , 
							margin : new go.Margin(0,0,0,0),
						},
						goMake( go.Shape , 'RoundedRectangle' , 
							{ 
								name: 'NodeShape',
								strokeWidth:1,
								fill:"#FFFFFF",
								stroke: "#DDDDDD",
								stretch: go.GraphObject.Fill,
								parameter1:5,
							} ,
							new go.Binding("figure","data",(data)=>{
								let figure = "capsuleH";
								// if(data.V === true || data.L === true){
								// 	figure = "RoundedRectangle";
								// }
								return figure;
							}).ofObject(),
						), 
						goMake(go.Panel, "Horizontal",
							goMake( go.TextBlock,
								{ 
									name : 'textValue' , 
									editable : this.nodeEditable , 
									maxLines : 1 , 
									textAlign: 'center' , 
									font : `bold 13px 'fontello', 'Pretendard', 'NanumSquare', sans-serif` , 
									stretch: go.GraphObject.Fill,
									maxSize : new go.Size( 300 , 28 ) , 
									minSize : new go.Size( 10 , 28 ) , 
									overflow : go.TextBlock.OverflowEllipsis , 
									verticalAlignment : go.Spot.Center , 
									stroke : '#666666' , 
									position : go.Point.stringify ,
									toolTip: goMake("ToolTip",
										goMake( go.TextBlock,
											{margin:4},
											new go.Binding("text","",toolTipHandler)
										)
									) 
								},
								new go.Binding( "text" ) ,
								// {
								// 	toolTip: goMake("ToolTip",
								// 		goMake( go.TextBlock,
								// 			{margin:4},
								// 			new go.Binding("text","",toolTipHandler)
								// 		)
								// 	),
								// }
								new go.Binding("margin","data",(data)=>{
									let margin = new go.Margin(0,data["M"] === true ? 3 : 30,0,30); // top , right , botton , left
									if( this.treeMode == "templete" || this.treeMode == "normal"
											&& (data["R"] || data["C"])
											&& (( data["L"] || data["V"] ) || data.text.length >= 10) ){
										margin = new go.Margin(0,data["M"] === true ? 3 : 30,0,30); // top , right , botton , left
									}
									return margin;
								}).ofObject(),
							) , 
							goMake( go.TextBlock,"*",
									{
										font	: `bold 20px 'fontello', 'Pretendard', 'NanumSquare', sans-serif` ,
										stroke 	: `#FF0000` ,
										
										margin	: new go.Margin(0,27,0,0),
									},
									new go.Binding("visible", "data", data => data["M"] === true ? true : false).ofObject(),
							),
						),
					),
					goMake( 'Button' , 
						{
							name : 'memoBtn' , 
							width : 21 , height : 25 , 
							alignment: go.Spot.TopLeft, 
							// alignment : new go.Spot ( 0, 0, 0, 0 ),
							alignmentFocus: go.Spot.Left,
							margin : new go.Margin(0,0,0,0) , // top , right , botton , left
							'ButtonBorder.stroke': null,
							'ButtonBorder.spot1': new go.Spot( 0,0,0,0 ), 
							'ButtonBorder.spot2': new go.Spot( 1,1,0,0 ), 
          					'_buttonStrokeOver': null, 
							'_buttonFillNormal': "red", 
							'_buttonFillDisabled': "red", 
							'_buttonFillOver': null, 
							'_buttonFillPressed': null, 
							'ButtonBorder.figure':'Circle',
							click : ( e , obj ) => {
								this.diagram.select( this.diagram.findNodeForKey( obj.part.data.key ) );
								this.memoObj.initHandler() ; 
							} , 

							// visible : false , 
						} , 
						goMake( go.Picture , 
							`${ require('@/assets/icons/open-memo-top.svg')}` , 
							{
								width : 20.5 , 
								height : 24 ,  
							}
						) , 
						// goMake( go.TextBlock , 'Click Me!' ) , 

						new go.Binding( 'visible', 'data' , ( data ) => {
							// console.log({ data }) ; 
							if ( data.visible == true ) {
							}
							// console.log({ data , visible : data.visible }) ; 
							// return data.visible || false ; 
							return data.visible ; 
						}).ofObject() , 
					) , 
					// the expand/collapse button, at the top-right corner
					goMake("TreeExpanderButton",
						{
							name : 'TREEBUTTON' , 
							row : 1 , column : 1 , 
							alignment : new go.Spot(0.96, 0.5, 0, 0) , 
							alignmentFocus : go.Spot.Center ,
						} , 
						{  
							'ButtonBorder.figure':'roundedRectangle',
							"ButtonBorder.stroke": "#b3b9bd",
							'ButtonBorder.fill': '#FFFFFF',
							"ButtonIcon.stroke": "#b3b9bd",
							'ButtonIcon.scale': 1 ,
						} ,
						new go.Binding("opacity", "isTreeLeaf", leaf =>{
							let btnVisible = true;
							if( this.expanderButtonVisible ){
								btnVisible = false;
							}
							return btnVisible;
						} ).ofObject()
					) , // end TreeExpanderButton
					goMake("CheckBox", "display",
						{
							"name": "radio",
							"Button.width": 18,
							"Button.height": 18,
							"ButtonBorder.figure": "Circle",
							"ButtonBorder.stroke": "#19A4AD",
							"ButtonIcon.figure": "Circle",
							"ButtonIcon.fill": "#19A4AD",
							"ButtonIcon.strokeWidth": 0,
							"ButtonIcon.desiredSize": new go.Size(7, 7),
							"alignment": new go.Spot(0, 0.5, 17, 0),
							"alignmentFocus" : go.Spot.Center ,
							click: (event,object) => {
								this.diagram.select( this.diagram.findNodeForKey( object.part.data.key ) );
							},
						},
						new go.Binding("visible", "data", data => {
							//radio button 노출 조작.
							let resultFlag = ( (this.treeMode == "templete" || this.treeMode == "normal") && data["R"] ) ? true : false
							return resultFlag;
						}).ofObject(),
					),
					goMake("CheckBox", "display",
						{
							"name": "check",
							"Button.width": 18,
							"Button.height": 18,
							"ButtonBorder.figure": "roundedRectangle",
							"ButtonBorder.fill"  : "#FFFFFF",
							"ButtonBorder.stroke"  : "#19A4AD",
							"ButtonIcon.stroke": "#FFFFFF",
							"ButtonIcon.strokeWidth": 2,
							"ButtonIcon.desiredSize": new go.Size(12, 12),
							"alignment": new go.Spot(0, 0.5, 17, 0),
							"alignmentFocus" : go.Spot.Center ,
							click: (event,object) => {
								this.diagram.select( this.diagram.findNodeForKey( object.part.data.key ) );
							},
						},
						new go.Binding("visible", "data", data => {
							//check button 노출 조작.
							let resultFlag = ( (this.treeMode == "templete" || this.treeMode == "normal" ) && data["C"] ) ? true : false
							return resultFlag;
						}).ofObject(),
					),
					this.addNodeLabel(),
				) ,  // end Node
        // linkTemplate: this.linkTemplate, // 트리구조라 링크데이터가 없으므로 삭제해도 될 것으로 보인다.
				linkTemplate : goMake(go.Link,
					{ routing: go.Link.Orthogonal, corner: 10 },
					goMake(go.Shape, { strokeWidth: 1, stroke:"#b3b9bd", }),
					// goMake(go.Shape, { toArrow: "OpenTriangle", strokeWidth: 1, stroke:"#999", width:5, })
				)
      });

			function toolTipHandler(node) {  // Tooltip info for a node data object
				return node.text;
			}

			const nodeTitleEditor = new go.HTMLInfo();
			let textInputOn = false;
			let titleInput = document.createElement('input');
			let textInputKeyDownHandler =(event)=> {};
				titleInput.addEventListener('keydown', event => {
				textInputKeyDownHandler(event)
			}, false);
			titleInput.style.textAlign = 'center';
			titleInput.style.padding = '3px 5px';
			titleInput.style.borderRadius = '5px';
			titleInput.style.zIndex = 100;
			titleInput.id = "eleTitleInput";

			const nodeDataUpdate = (diagram, tool)=>{
				let selectedNode = diagram.selection.first();

				if( !titleInput.value ) return;

				if( this.treeMode == "templeteEdit" ){
					this.selectedIssue.find(o=>o.key == selectedNode.data.key).text = titleInput.value;
				}else{
					let { protocols } = this.PROCESS_INFO ; 
					let { protocolId } = this.$route.query ; 
					const slctProtocol = protocols?.filter( protocol => protocol.id == protocolId )[0] ; 
					if( typeof slctProtocol.json === "string" ) slctProtocol.json = JSON.parse(slctProtocol.json);
					slctProtocol.json.issues.find(o=>o.key == selectedNode.data.key).text = titleInput.value;
				}
				selectedNode.data.text = titleInput.value;
				if( diagram.div.querySelector("#eleTitleInput") ){
					diagram.div.removeChild(titleInput);
				}
			}

			nodeTitleEditor.show = (textBlock, diagram, tool) => {

				let selectedNode = diagram.selection.first();
				//템플릿 생성모드가 아닐때 D 속성을 가지고 있지 않으면 이름 편집불가
				if( this.treeMode == "readonly" || ( this.treeMode != "templeteEdit" && !selectedNode?.data["D"] ) ){
					tool.doCancel();
					return;
				}
				if(!(textBlock instanceof go.TextBlock)){
					tool.doCancel();
					return;
				} 
				let selectedNodeBound = selectedNode.actualBounds;
				titleInput.value = '';
				// console.log(selectedNodeBound, textBlock.actualBounds);
				textInputKeyDownHandler = (keyEvent) => {
					switch(keyEvent.key) {
						case 'Escape' :
							tool.doCancel();
							break;
						case 'Enter' :
							tool.acceptText(go.TextEditingTool.Enter);
							// tool.doDeactivate();
							// tool.stopTool()
							nodeDataUpdate(diagram, tool);
							tool.doMouseDown();
						break;
					}
					return;
				}

				let loc = textBlock.getDocumentPoint(go.Spot.TopLeft);
				let pos = diagram.transformDocToView(loc);
				
				titleInput.value = textBlock.text;
				// selectedNode.width = selectedNodeBound.width + 100;
				titleInput.style.left = `${pos.x}px`;
				titleInput.style.top = `${pos.y}px`;
				titleInput.style.position = 'absolute';
				titleInput.style.height = `${textBlock.actualBounds.height}px`;
				// titleInput.style.width = `${textBlock.actualBounds.width}px`;
				titleInput.style.width = `${textBlock.actualBounds.width + 150}px`;
				titleInput.style.textAlign = "left";
				
				textInputOn = true;

				diagram.div.appendChild(titleInput);
			}
			nodeTitleEditor.hide = (diagram, tool) => {
				if( !textInputOn ) return ;
				nodeDataUpdate(diagram);
				textInputOn = false;
			}

			nodeTitleEditor.valueFunction = () =>{
				if( !textInputOn ) return ;
				let selectedNode = this.diagram.selection.first();
				let nodeText = "";
				if( this.treeMode == "readonly" || ( this.treeMode != "templeteEdit" && !selectedNode.data["D"] ) ){
					nodeText = selectedNode.data.text;
				}else{
					nodeText = titleInput.value;
				}
				return nodeText;
			} 

			this.diagram.toolManager.textEditingTool.defaultTextEditor = nodeTitleEditor;
			this.diagram.toolManager.textEditingTool.starting = go.TextEditingTool.DoubleClick;

			this.diagram.toolManager.textEditingTool.textValidation = (o,oldText,newText)=>{
				if( newText ) return true;
				else return false;
			}

			this.diagram.layout.commitNodes = () => { // 노드 업데이트될 경우 진입 
				go.TreeLayout.prototype.commitNodes.call(this.diagram.layout)
				this.diagram.layout.network.vertexes.each( v => {
					if(v.node) {
						const { data , data : { V, L, P, H, R, C, display, category, parent }} = v.node ; 
						const shape = v.node.findObject('NodeShape'); 
						const text = v.node.findObject('textValue');
						const radioBtn 	= v.node.findObject('radio').findObject("ButtonIcon");
						const checkBtn 	= v.node.findObject('check');
						if(radioBtn){
							if(R === true) {
								radioBtn.visible = display;
							}
						}
						if(checkBtn){
							if(C === true) {
								let checkBtnIcon = checkBtn.findObject("ButtonIcon");
								let checkBtnBorder = checkBtn.findObject("ButtonBorder");
								checkBtn["_buttonFillNormal"] = display ? "#19A4AD" : "#FFFFFF";
								checkBtnBorder["fill"] = display ? "#19A4AD" : "#FFFFFF";
								checkBtnIcon.visible = display;
							}
						}
						if(shape) {
							if( P === true ){
								shape.fill = "#E8F6F7";
								shape.stroke = "#19A4AD";
								text.stroke = "#0E0F0F";
								if (H === true) {
									shape.fill = "#cccccc";
									shape.stroke = "#DDDDDD";
								}
							}else if( H === true ){
								shape.fill = "#cccccc";
							// }else if( V === true || L === true ){
								// shape.figure = "RoundedRectangle";
								// shape.fill = "#FFFFFF";
								// shape.stroke = "#DDDDDD";
								// text.stroke = "#333333";
								// text.textAlign = 'left';
							}else{
								shape.figure = "capsuleH";
								const parentNode = this.selectedIssue.filter(o=>o.key===parent)[0];
								if( parentNode && parentNode["T"] === true ){
									shape.fill = "#FFFFFF";
									shape.stroke = "#DDDDDD";
								}else{
									shape.fill = "#FFFFFF";
									shape.stroke = "#DDDDDD";
								}
							}
							// console.log(  )
						} // end of if 
					} // end of if 
				}) ; // end of diagram 
			} ; // diagram.layout.commitNodes 

			//삭제 기능을 차단합니다.
			this.diagram.commandHandler.doKeyDown = function(){
				var e = this.diagram.lastInput;
				let { key } = e ;

				const disabledKeys = ["Del","Backspace"];
				if( !disabledKeys.includes(key) ){
					go.CommandHandler.prototype.doKeyDown.call(this);
				}
			};

			// this.diagram.commandHandler.copiesParentKey = true;


			//복사해서 붙여넣기 기능을 차단합니다.
			let clipboardNodes = [];

			const findAllTreeChildrenNodes = this.findAllTreeChildrenNodes;
			this.diagram.commandHandler.copySelection = ()=> {
				clipboardNodes = [];
				if( this.treeMode != "templete" && this.treeMode != "templeteEdit" ){
					window.wToast("복사하기는 템플릿 모드에서만 사용가능합니다." , {variant: "wtoast-bg",}) ; 
					return;
				}				
				if( this.diagram.selection.count == 0 ){
					window.wToast("복사할 노드를 선택하세요" , {variant: "wtoast-bg",}) ; 
					return;
				}
				
				if( this. diagram.selection.count > 1 ){
					window.wToast("복사 시에는 1개의 노드만을 선택하세요." , {variant: "wtoast-bg",}) ; 
					return;
				} 

				go.CommandHandler.prototype.copySelection.call(this.diagram.commandHandler);

				let selectedNode = this.diagram.selection.first();
				delete selectedNode.data.__gohashid;
				let cloneNode = JSON.parse(JSON.stringify(selectedNode.data));
				cloneNode.key = v4();
				clipboardNodes.push(cloneNode)
				const childNodes = findAllTreeChildrenNodes(selectedNode);
				childNodes.map((childNode) => {
					if( childNode.data.category == "CHILD" ){
						cloneNode = JSON.parse(JSON.stringify(childNode.data));
						cloneNode.key = v4();
						delete cloneNode.__gohashid;
						clipboardNodes.push(cloneNode)
					}
				});

				window.wToast("선택한 노드와 하위노드가 복사되었습니다." , {variant: "wtoast-bg",}) ; 
		
			};

		
			this.diagram.commandHandler.pasteSelection  = ()=> {
				if( this.treeMode != "templete" && this.treeMode != "templeteEdit" ){
					window.wToast("붙여넣기는 템플릿 모드에서만 사용가능합니다." , {variant: "wtoast-bg",}) ; 
					return;
				}	
				
				if( this.diagram.selection.count == 0 ){
					window.wToast("붙여넣기할 노드를 선택하세요" , {variant: "wtoast-bg",}) ; 
					return;
				}
				if( this.diagram.selection.count > 1 ){
					window.wToast("붙여넣기 시에는 1개의 노드만을 선택하세요." , {variant: "wtoast-bg",	}) ; 
					return;
				} 

				if( clipboardNodes.length == 0 ){
					window.wToast("노드 복사후 붙여넣기 하세요." , {variant: "wtoast-bg",	}) ; 
					return;
				} 

				let selectedNode = this.diagram.selection.first();
				console.log("clipboardNodes", clipboardNodes )
				clipboardNodes[0].parent = selectedNode.data.key;

				const { model } = this.diagram;

				
				// go.CommandHandler.prototype.pasteSelection.call(this.diagram.commandHandler);

				const protocolId = clipboardNodes[0].protocolId;
				let { protocols } = this.PROCESS_INFO; 
				const slctProtocol = protocols?.filter( protocol => protocol.id == protocolId )[0] ; 
				if( typeof slctProtocol.json === "string" ) slctProtocol.json = JSON.parse(slctProtocol.json);
				for( let cloneNode of clipboardNodes ){
					const searchNode = slctProtocol.json.issues.filter(o=>o.key == cloneNode.key)[0];
					if( searchNode ){
						searchNode.parent = cloneNode.parent;
					}else{
						slctProtocol.json.issues.push(cloneNode)
					}
					const parentNode = this.diagram.findNodeForKey( cloneNode.parent );
					// console.log( "parentNode", parentNode )
					cloneNode.depth = parentNode.data.depth + 1;
					// console.log( "cloneNode", cloneNode )
					model.addNodeData(cloneNode);
				}
				// go.CommandHandler.prototype.pasteSelection.call(this.diagram.commandHandler);
				// this.diagram.commitTransaction('paste');
				// this.diagram.layoutDiagram(true);
				clipboardNodes = [];

			};
			this.diagram.commandHandler.cutSelection   = ()=> {
				if( this.treeMode != "templete" && this.treeMode != "templeteEdit" ){
					window.wToast("잘라내기는 템플릿 모드에서만 사용가능합니다." , {variant: "wtoast-bg",}) ; 
					return;
				}
				clipboardNodes = [];
				if( this.diagram.selection.count == 0 ){
					window.wToast("잘라내기할 노드를 선택하세요" , {variant: "wtoast-bg",}) ; 
					return;
				}
				if( this.diagram.selection.count > 1 ){
					window.wToast("잘라내기 시에는 1개의 노드만을 선택하세요." , {variant: "wtoast-bg",}) ; 
					return;
				} 

				go.CommandHandler.prototype.copySelection.call(this.diagram.commandHandler);

				let selectedNode = this.diagram.selection.first();
				delete selectedNode.data.__gohashid;
				let cloneNode = JSON.parse(JSON.stringify(selectedNode.data));
				clipboardNodes.push(cloneNode)
				const childNodes = findAllTreeChildrenNodes(selectedNode);
				childNodes.map((childNode) => {
					if( childNode.data.category == "CHILD" ){
						cloneNode = JSON.parse(JSON.stringify(childNode.data));
						delete cloneNode.__gohashid;
						clipboardNodes.push(cloneNode)
						this.diagram.remove(childNode)
					}					
				});
				this.diagram.remove(selectedNode)
				window.wToast("선택한 노드와 하위노드가 잘라내기되었습니다." , {variant: "wtoast-bg",}) ; 
				console.log( "childNodes", clipboardNodes )
			};

			this.diagram.addDiagramListener("AnimationStarting", function(e, obj ) {
				// e.diagram.initialContentAlignment = go.Spot.Center ; 
			});

			this.diagram.addDiagramListener("InitialLayoutCompleted", function(e , obj ) {
				e.diagram.animationManager.isEnabled = true ; 
				e.diagram.findTreeRoots().each(function(r) { 
					// r.expandTree(1); 
				});
				setTimeout(_=> {
					e.diagram.contentAlignment = go.Spot.None 
					//추가된 객체로 인해 벌어진 연결선을 다시 그려주세요.
					e.diagram.links.each(function(link) {
						link.invalidateRoute();
					});	
				} , 100 ) ; 
				// setTimeout(_=> e.diagram.contentAlignment = new go.Spot(0.25, 0.5, 0, 0)); 
				// console.log( Object.keys( go.Spot )) ; 
			});
            this.diagram.addModelChangedListener(( e )=> {
				// console.log({ 
				// 	e , 
				// 	isTransactionFinished : e.isTransactionFinished , 
				// 	change : e.change , 
				// 	modelChange : e.modelChange , 
				// 	newValue : e.newValue , 
				// 	oldParam : e.oldParam , 
				// 	oldValue : e.oldValue , 
				// 	propertyName : e.propertyName , 
				// 	crntProtocols : this.crntProtocols
				// }) ; 

				if ( e.oldValue == 'Initial Layout' ) return ; 
				if ( e.newValue == null && e.isTransactionFinished == false ) return ; 

				// 자동저장 타이머
				if(this.autoSaveTimer) { 
					clearTimeout(this.autoSaveTimer) 
					// console.log('Clear save timer')
				}
				this.saveTimer()
			}) ; 
			this.diagram.padding = new go.Margin(120, 0, 150, 0);
			this.commandHandler = this.diagram.commandHandler ; 
			// console.log( this.commandHandler.undoManager ) ; 
			// if (!this.commandHandler.undoManager) {
			// 	console.log( 'ia' ); 
			// 	this.commandHandler.undoManager = new go.UndoManager(); 
			// }

			// this.undoManager = this.commandHandler.undoManager;
			// this.undoManager.isEnabled = true;

			// this.diagram.commitTransaction("make new group");
			if( this.treeMode != "readonly" && !this.newProtocolViewBln ){
				this.overview = new go.Overview('editor-overview', {
					observed: this.diagram
				})
			}
			this.setCrntDiagram( this.diagram ) ; 
			if ( this.firstBln ) return ; 
			this.setModel()
		},

		async setModel () {
			// console.log({ selectedIssue : this.selectedIssue }) ; 

			// const commentData = [
			// 	{ key: 1, text: "Epsilonasdfasdfasdfq234sdf asdfqwe4 asdf 234 sadf2334124321", parent:"issue-9b471a7e-a3f0-4664-bfa7-1d0ba4572ba2", category : "SHORTVALUE", visible:false, subData : [ { n : "test2" } ], },
			// 	{ key: 2, text: "Zetaasdfasdfq234sdf asdfqwe4 asdf 234 sadf2334124321", parent:"issue-a2834e04-8965-4ac3-b052-22fc6749b9d6", category : "SHORTVALUE", visible:false,   }
			// ];

			this.diagram.model = new go.TreeModel(this.selectedIssue);
			// this.diagram.model.addNodeDataCollection(commentData);

			
			// if ( this.diagram.findNodeForKey ) {
			// 	this.diagram.select( this.diagram.findNodeForKey( this.slctProtocolKey ) );
			// } 
		},

		async rendModel(){
			if ( this.diagram.findNodeForKey ) {
				this.diagram.select( this.diagram.findNodeForKey( this.slctProtocolKey ) );
			} 			 
		},
		getContext(data) {
			this.contextMenu = data;
        },
		async modeChange(mode){
/*			
			tree모드에서 값을 입력하도록 수정함에 따라서 해당 validation 주석 처리 > 문의 후 재구현. by hhw 

			if( mode == "normal" ){
				// console.log( this.selectedIssue );
				let validList = {};
				for( let parentNode of this.selectedIssue.filter(o=>o.T === true && o.display === undefined ) ){
					for( let node of this.selectedIssue.filter(o=>o.parent === parentNode.key ) ){
						if( node.R === true ){
						if( !validList["R"] ) validList["R"] = {};
						if( !validList["R"][node.parent] ) validList["R"][node.parent] = [];
							validList["R"][node.parent].push( node );
						}
						if( node.C === true ){
							if( !validList["C"] ) validList["C"] = {};
							if( !validList["C"][node.parent] ) validList["C"][node.parent] = [];
							validList["C"][node.parent].push( node );
						}
					}
				}
				for( let nodeType in validList ){
					for( let parentKey in validList[nodeType] ){
						const validNode = validList[nodeType][parentKey].filter(o=>o.display===true);
						// console.log( validNode )
						if( !validList[nodeType][parentKey].filter(o=>o.display===true).length ){
							window.alert( "<b>R</b> 은 <b>1개</b> <b>C</b> 은 <b>1개 이상</b>의 노드를 선택해주세요." );
							return;
						}
					}
				}
				if( this.initChecked === true ){
					let { protocols } = this.PROCESS_INFO ; 
					for( let protocol of protocols ){
						if( typeof protocol.json == "string" ){
							protocol.json = JSON.parse(protocol.json);
						}
						if( protocol.id == this.$route.query.protocolId ){
							let nodeInfo = checkProtocolLink(this.PROCESS_INFO.links, this.PROCESS_INFO.nodes, protocol.keyOfProtocol);
							nodeInfo = nodeInfo.nodeInfo
							for(let item of Object.entries(nodeInfo)) {
								protocol[item[0].toLowerCase()] = Object.keys(item[1]);
							}
							delete protocol.json.init;
						}
					}
					this.initChecked = false;
				}
				// window.alert( "valid" );
			}*/

			if( mode === "normal" ){
				let nodeOptionCount=0;
				for( let node of this.selectedIssue ){
					if( node.category == 'SHORTVALUE' ) continue;
					nodeOptionCount=0;
					for( let opt of this.optionList ){
						// if( opt.key == "H" ) continue;
						if( node[opt.key] ) nodeOptionCount++;
					}
					if( !nodeOptionCount ){
						// console.log( "node", node );
						break;
					} 
				}
				if( !nodeOptionCount ){
					window.alert("노드 속성이 적용되지 않은 노드가 존재하여,<br/>저장이 불가합니다.");
					return;
				}
			}

			this.$emit('change', {"mode":mode});
			await this.saveHandler() ; 

		},	
		computeGeo ( v ) {
			if ( v.key == "issue-fafce3d8-c1b7-44cc-a28a-4d322b6105ed" ) {
				const node = this.diagram.findNodeForKey( v.key ) ; 
			}
		} , 

		nodeDisplayChange(node){
			if( !node.R && !node.C ) return;

			let { protocols } = this.PROCESS_INFO ; 
			let { protocolId } = this.$route.query ; 
			const slctProtocol = protocols?.filter( protocol => protocol.id == protocolId )[0] ; 
			if( typeof slctProtocol.json === "string" ) slctProtocol.json = JSON.parse(slctProtocol.json);


			let parentNode = this.diagram.findNodeForKey( node.parent ) ; 
			if( parentNode.data.display === false ){
				window.alert('부모노드를 먼저 선택해주세요.');
				return;
			}
			// this.selectedIssue
			// console.log( "issues", this.selectedIssue );
			// console.log( "slctProtocol", slctProtocol )
			// node

			this.diagram.model.nodeDataArray.map( async nodeInfo => {
				if( node.R ){
					if( nodeInfo.parent == node.parent ){
						nodeInfo.display = false ; 
						await slctProtocol.json.issues.find(o =>{
							if( o.parent === node.parent ){
								o.display = false;
							}
						});
						this.childNodeDisplayChange(slctProtocol,nodeInfo.key,nodeInfo.display);
					}
					if ( nodeInfo.key == node.key ) {
						nodeInfo.display = true ; 
						// console.log( slctProtocol.json.issues )
						await slctProtocol.json.issues.find(o =>{
							if( o.key === node.key ){
								o.display = nodeInfo.display;
							}
						});
						this.childNodeDisplayChange(slctProtocol,nodeInfo.key,nodeInfo.display);
					}
				}else if( node.C ){
					if ( nodeInfo.key == node.key ) {
						nodeInfo.display = nodeInfo.display ? false : true ; 
						await slctProtocol.json.issues.find(o =>{
							if( o.key === node.key ){
								o.display = nodeInfo.display;
							}
						});
						this.childNodeDisplayChange(slctProtocol,nodeInfo.key,nodeInfo.display);
					}
				}

			}) ; 

			// this.updateProtocols( protocols ) ; 

			// console.log( "slctProtocol.json.issues", protocols )

			// console.log( "slctProtocol.json.issues", slctProtocol )

		},
		childNodeDisplayChange(slctProtocol, key, display) {
			const currentNode = this.diagram.findNodeForKey(key);
			// const childrenNodes = currentNode.findTreeChildrenNodes();
			let childrenNodes = new go.Set();
			
			if( display === false ){
				childrenNodes = this.findAllTreeChildrenNodes(currentNode);
			}else{
				currentNode.findLinksOutOf().each((node)=>{
					if( !node.data.R && !node.data.C && ( node.data.V || node.data.L ) ){
						if (!childrenNodes.contains(node)) {
							childrenNodes.add(node);
						}
					}
				});
			}
			
			// console.log( "childrenNodes", childrenNodes)
			
			childrenNodes.map(async (childNode) => {
				childNode.data.display = display;
				await slctProtocol.json.issues.find((o) => {
					if (o.key === childNode.data.key) {
						o.display = display;
					}
				});
			});
		},

		findAllTreeChildrenNodes(node) {
			let children = new go.Set();

			function findChildNodes(currentNode, childrenSet) {
				if( currentNode ){
					currentNode.findLinksOutOf().each((link) => {
						const childNode = link.getOtherNode(currentNode);
						if (!childrenSet.contains(childNode)) {
							childrenSet.add(childNode);
							findChildNodes(childNode, childrenSet);
						}
					});
				}
			}
			
			findChildNodes(node, children);

			return children;
		},
		getImageUrl(key) {
			let name = "";
			this.optionList.forEach((object,index)=>{
			    if(object.key == key){
					name = object.name;
					return;
			    }
			});
			name += "_on.png";
			let url = require(`@/assets/protocol/${name}`);
			return url;
		},
    async aliveCheck() {
      try {
        this.loading = true
        const response = await this.$wApi.simultaneous.aliveCheck({
          relativeId: this.$route.query.protocolId,
          editKey: this.editKey,
        });
        //console.log('aliveCheck response ',response,'this.editKey = ',this.editKey)
        //TODO 네트워크 끊김에 따른 후처리 and editkey 유효성 검사를 통한 reload 필요
        if (!response.isEditMode) {
          //editkey 유효성 검사 실패에 따른 reload
          this.editStatusTitle = "유효하지 않은 세션";
          this.editStatusContent = "유효하지않은 세션입니다.<br/>관리모드로 새로고침됩니다.";
          this.editStatusAlert = true;
        }
        this.networkErrorCount = 0;
      } catch (e) {
        console.log(e)
        ++this.networkErrorCount;
        if (this.networkErrorCount == 5) {
          this.editStatusTitle = "네트워크 연결시도 실패";
          this.editStatusContent = "네트워크 연결 5회 실패하였습니다.<br/>네트워크 상태를 확인해주세요.";
          this.editStatusAlert = true;
        } else {
          alert(`네트워크가 연결되어있지 않습니다.<br/>연결시도 ${this.networkErrorCount}회 실패`);
        }
      } finally {
        this.loading = false
      }
    },
    async polling() {
      const timeOut = ms => new Promise(resolve => setTimeout(resolve, ms));
      await timeOut(Math.floor(this.editDuration / 2));
      if(this.pollingEndSwitch){
        return;
      }
      await this.aliveCheck();
      if (this.networkErrorCount < 5) {
        await this.polling();
      }
    },
	openDictionaryPopup(requestObj) {
		this.dictionaryPopup = {
			category: requestObj.category,
			changeTagFunc: requestObj.changeTagFunc,
			key: requestObj.key,
			processId: requestObj.processId,
			openBln : false , 
		    closeHandler : _=> this.dictionaryPopup.openBln = false ,
		};
		this.dictionaryPopup.openBln = true;
  	},
		
	}
}
</script>

<style lang="scss">
	#editor-protocol>div{
		transition: all 80ms cubic-bezier(0.4, 0, 0.2, 1);;
	}
	.editorProtocol {
		height: 100%;
	}
	#editor-protocol {
		height: 100%;
		div {
			@include scrlbar; 
		}
	}
	.editorBtmWrap {
		position: relative; 
		// right: var( --default-gap ); 
		// bottom: var( --default-gap ); 
		// right: 20px; bottom: 20px; 
		gap: var( --default-gap ); 
		display: flex; 
		flex-direction: column; 
		align-items: flex-end; 
		z-index: 10; 

		.template , .approvalRequest {
			@include text-prt; 
			@include text-prt-sb; 
		}

		.template {
			display: inline-flex; align-items: center; justify-content: center;
			height: 32px;
			padding: 8px 16px;
			color: $gray-6; 
			font-size: 14px; 
			background-color: $white; 
			border-radius: 3px; 
			border: 1px solid #ddd;
			cursor: pointer; 
		}

		.mode{
			display: flex; align-items: center; gap: 2px;
			position:relative;
			padding: 8px 16px 8px 35px;
			border: 1px solid #CCCCCC;
			border-radius: 2px;
			font-size:14px;
			background:#fff;
			box-shadow: 0px 4px 16px rgba(91, 91, 91, 0.2);
			border-radius:30px;
			&:before {
				content: '';
				// display: inline-block;
				position:absolute;
				left:15px;
				width: 17px; height: 17px;
				background: url('../../assets/icons/eye-fill.svg') center no-repeat;
			}
			&.normal{
				&:before {
					background: url('../../assets/icons/eye-line.svg') center no-repeat;
				}
			}			
			&.unit{
				&:before {
					background: url('../../assets/icons/unit-line.svg') center no-repeat;
				}
			}				
			&.setting{
				background:#DAE8F8;
				&:before {
					background: url('../../assets/icons/unit-line.svg') center no-repeat;
					background-size: contain;
				}
			}
		}

		.approvalRequest {
			width: 119px; height: 33px; 
			background-color: $gray-e; 
			border: 1px solid $gray-c; 
			font-size: 14px; 
		}
	}

	.undoRedoWrap {
    position: fixed; bottom: 50px; left: 50%;
    height: 44px; 
    transform: translateX( -50% ); 
    border: 0; 
    z-index: 10; 
    display: flex; 
    flex-direction: row; 
    justify-content: center; 
    align-items: center; 
    padding: 10px 16px; 
    gap: 16px; 
    background: $white; 
    box-shadow: 0px 4px 16px rgb(113 150 255 / 30%); 
    border-radius: 40px; 

		&::after {
			content: ''; 
			width: 1px; 
			display: flex; 
			background-color: $gray-d; 
			position: absolute; 
			left: 50%; top: 12px; bottom: 12px; 
		}

		> button {
			width: 24px; height: 24px; 
			display: flex; 
			cursor: pointer; 
			background-repeat: no-repeat; 
			background-position: center center; 
			font-size: 0; 
			line-height: 0; 
			&.unused {
				filter: grayscale(1) brightness(2); 
			}
		}
		.undo {
			background-image: url('@/assets/icons/undo.svg'); 
		}
		.redo {
			background-image: url('@/assets/icons/redo.svg'); 
		}
	}

	
</style>
